
export const name = "at-error";

export function create(err: Error): CustomEvent {
    return new CustomEvent(name, {detail: err, bubbles: true, cancelable: true, composed: false});
}
